/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import classNames from 'classnames/bind'
import * as styles from './Checkbox.scss'

const cx = classNames.bind(styles)

interface IProps  {
  label?: string,
  size?: 'small' | 'medium' | 'large',
  value?: any,
  styleType?: 'default' | 'inputCenter' | 'onlyCheckbox',
  disabled?: boolean,
}

const Checkbox: React.SFC<IProps> = ({ styleType = 'default', label, size, disabled, ...restProps }) => {
  return (
    <label
      className={cx('root', size, styleType, { disabled })}
    >
      <input {...restProps} className={styles.input} type='checkbox' disabled={disabled} />
      <span className={cx('icon', { disabled })} tabIndex={0} />
      <span className={styles.label}>{label}</span>
    </label>
  )
}

export default Checkbox
